import React from "react";
import getImagePath from "helpers/get-image-path";
import { singleImageSection, singleImage, singleImageTitle } from "./style.mod.scss";

const SingleImage = ({ data }) => {

  const { image, bgColor, title } = data;
  const alt = image?.alt?.replace("Olav ", "Olavson ");
  return (
    <div className={singleImageSection} 
      style={{ backgroundColor: bgColor?.hex }}>
      <div className={singleImage}>
        <h2 className={singleImageTitle}>{title}</h2>
        <img src={getImagePath(image, true)} alt={alt}/>
      </div>
    </div>
  );
};

export default SingleImage;